type TCatalogueEntry = {
  id: string;
  parameters?: { main_logo_presigned_url?: string } | null;
};

/**
 * Fills each entry's thumbnail from the logo/people catalogue, keeping the one it
 * already carries when the catalogue does not know the entity — the catalogue is
 * paginated, so an older record may simply not be in the loaded page.
 *
 * Returns the received array untouched when nothing resolved, so a refetch that
 * changes no thumbnail neither re-renders the chips nor discards their identity.
 */
function withResolvedImages<TItem extends { image?: string }>(
  items: TItem[],
  idKey: keyof TItem,
  catalogue: TCatalogueEntry[]
): TItem[] {
  let hasChanges = false;

  const resolved = items.map(item => {
    const image = catalogue.find(entry => entry.id === item[idKey])?.parameters
      ?.main_logo_presigned_url;

    if (!image || image === item.image) return item;

    hasChanges = true;
    return { ...item, image };
  });

  return hasChanges ? resolved : items;
}

export { withResolvedImages };
